import styled from "styled-components";
import {Link} from "react-router-dom";
import {linkColor} from "../themes/color";

const BackContainer = styled(Link)`
  position: fixed;
  display: flex;
  left: .5rem;
  top: .5rem;
  padding: .5rem;
  align-items: center;
  text-decoration: none;
  ${linkColor};

  @media print {
    display: none;
  }
`;

const BackHeader = () => {
  return (
    <BackContainer to='/'>
      <i className='material-icons'>west</i>
    </BackContainer>
  );
};

export default BackHeader;
